"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NicamIconsPositions = exports.LinkType = exports.LogoPositions = exports.TitlePositions = void 0;
var TitlePositions;
(function (TitlePositions) {
    TitlePositions["TOP_LEFT"] = "top-left";
    TitlePositions["TOP_RIGHT"] = "top-right";
    TitlePositions["BOTTOM_LEFT"] = "bottom-left";
    TitlePositions["BOTTOM_RIGHT"] = "bottom-right";
})(TitlePositions || (exports.TitlePositions = TitlePositions = {}));
var LogoPositions;
(function (LogoPositions) {
    LogoPositions["TOP_LEFT"] = "top-left";
    LogoPositions["TOP_RIGHT"] = "top-right";
    LogoPositions["BOTTOM_LEFT"] = "bottom-left";
    LogoPositions["BOTTOM_RIGHT"] = "bottom-right";
    LogoPositions["CONTROL_BAR"] = "control-bar";
})(LogoPositions || (exports.LogoPositions = LogoPositions = {}));
var LinkType;
(function (LinkType) {
    LinkType["STATIC"] = "static link";
    LinkType["KIJK"] = "link to KIJK video";
    LinkType["NO_LINK"] = "no link";
})(LinkType || (exports.LinkType = LinkType = {}));
var NicamIconsPositions;
(function (NicamIconsPositions) {
    NicamIconsPositions["TOP_LEFT"] = "top-left";
    NicamIconsPositions["TOP_RIGHT"] = "top-right";
})(NicamIconsPositions || (exports.NicamIconsPositions = NicamIconsPositions = {}));
